export { Avatar, renderAvatar, useAvatar } from './components/Avatar/index';
export type { AvatarSlots, AvatarProps, AvatarState } from './components/Avatar/index';
